import { API_ORIGIN, useAuth } from '@yeshuman/sdk'
import { useQuery } from '@tanstack/react-query'


export interface OrganisationSkill {
  id: string
  name: string
}

const EMPTY_SKILLS: OrganisationSkill[] = []

export function useOrganisationSkills(organisationSlug: string) {
  const { token } = useAuth()
  const slug = organisationSlug.trim()

  const query = useQuery({
    queryKey: ['organisation-skills', slug],
    enabled: Boolean(token && slug),
    queryFn: async (): Promise<OrganisationSkill[]> => {
      const response = await fetch(
        `${API_ORIGIN}/api/organisations/managed/${encodeURIComponent(slug)}/skills/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      if (!response.ok) {
        throw new Error(`Failed to fetch organisation skills: ${response.status}`)
      }
      return response.json()
    },
  })

  return {
    skills: query.data ?? EMPTY_SKILLS,
    isLoading: query.isLoading,
    error: query.error,
  }
}
